export default __webpack_public_path__ + "static/media/fontRoboto700_latin.227c9319.woff2";